import { render } from "./compra.vue?vue&type=template&id=0ebfdec7"
import script from "./compra.vue?vue&type=script&lang=js"
export * from "./compra.vue?vue&type=script&lang=js"

import "./compra.vue?vue&type=style&index=0&id=0ebfdec7&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__